import { Action } from 'redux';
import ActionDTO from 'src/entities/basic-types/ActionDTO';
import { action } from 'src/store/actions';

export const ACTION_DTO = 'ACTION_DTO';
export const REQUEST_ACTION_DTO = 'REQUEST_ACTION_DTO';
export const SUCCESS_ACTION_DTO = 'SUCCESS_ACTION_DTO';
export const FAILURE_ACTION_DTO = 'FAILURE_ACTION_DTO';

export const actionDTO = <T>(dto: ActionDTO<T>, successAction?: Action<any>, successCallback?: () => void) =>
    action(ACTION_DTO, { dto, successAction, successCallback });
export const requestactionDTO = () => action(REQUEST_ACTION_DTO);
export const actionDTOSuccess = (response: any) => action(SUCCESS_ACTION_DTO, { response });
export const actionDTOFailure = (error: any) => action(FAILURE_ACTION_DTO, { error });
